import MemberArticlePanel from "./MemberArticlePanel";

/** Members' Desk — the blog / long read. Reads/writes the exact article Master Build creates. */
export default function MembersDeskSection({ member, article, onArticleChange }) {
  return (
    <MemberArticlePanel
      member={member} article={article} onArticleChange={onArticleChange}
      kind="blog" sectionId="section-desk" tid="desk"
      heading="Members' Desk" note="blog & long reads"
      publicNote="Publish Now sends this live to the magazine under Members' Desk."
    />
  );
}
